import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Feature } from 'ol';
import { ip } from 'src/app/constant/constant';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { ToastService } from 'src/app/services/toast.service';
import { FavoriteRecordsService } from 'src/app/services/favorite-records.service';
import { ContentData, FavoriteCheckResponse } from '../add-content/models/content.model';
import { StoreLinkService } from 'src/app/services/marketplace/store-link.service';

@Component({
    selector: 'app-content-creator-modal-detail',
    templateUrl: './content-creator-modal-detail.component.html',
    styleUrls: ['./content-creator-modal-detail.component.scss'],
    standalone: false
})
export class ContentCreatorModalDetailComponent implements OnInit, OnDestroy {
  @Input() data: ContentData;
  @Input() feature: Feature;
  ip: any = ip;
  currentUserSubscription: Subscription;
  userId: string | number;
  isFavoriteLoading: boolean = true;
  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private dataFetchService: DataService,
    private currentUserService: CurrentUserService,
    private favoriteRecordsService: FavoriteRecordsService,
    private toasterService: ToastService,
    private cdr: ChangeDetectorRef,
    private storeLinks: StoreLinkService,
  ) { };
  ngOnDestroy(): void {
    this.currentUserSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    console.log(this.data);
    this.setupCurrentUser();
  }

  setupCurrentUser() {
    this.currentUserSubscription =
      this.currentUserService.currentUser.subscribe({
        next: (user) => {
          if (user) {
            this.userId = user.id;
            this.checkCurrentContentFavorite();
          }
        
          this.cdr.detectChanges();},
      });
  }

  checkCurrentContentFavorite() {
    this.isFavoriteLoading = true;
    this.dataFetchService.checkFavorite(this.userId, this.data.wp_usage_id,).subscribe({
      next: (res: FavoriteCheckResponse) => {
        this.data.favorited = !!res.favorited;
        this.isFavoriteLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isFavoriteLoading = false;
      
          this.cdr.detectChanges();}
    });
  }
  navigateToContentPage() {
    this.activeModal.close();
    console.log(this.data, this.data.wp_creator_id, this.userId); 

    let coordString = '';
    if (this.feature) {
      const geometry: any = this.feature.getGeometry();
      const coords = geometry.getCoordinates();
      coordString = `${coords[0]},${coords[1]}`;
    }

    const url = this.router.serializeUrl(
      this.router.createUrlTree(['add-edit-content'], {
        queryParams: {
          id: this.data.id,
          mode: 'edit',
          isEditable: this.data.access_type && this.data.access_type?.toLowerCase() === 'creator',
          see_on_map_coordinates: coordString,
          citycode: this.data.citycode ?? 'null',
          mapcode: this.data.pins[0].map_id ?? 'null',
        },
      })
    );

    // Build full URL
    let fullUrl = '';
    if (window.location.origin.includes('app.worldtumbler.com') || window.location.origin.includes('testapp.worldtumbler.com')) {
      fullUrl = `${window.location.origin}/application/${url}`;
    }
    else {
      fullUrl = `${window.location.origin}/${url}`;
    }

    // Open in new tab
    window.open(fullUrl, '_blank');
  }

  markThisContentToFavorite() {
    this.toggleFavroite(this.userId, this.data.citycode ? true : false);
  }

  toggleFavroite(userId, isCity: boolean) {
    this.isFavoriteLoading = true;
    this.dataFetchService.saveContentToFavorites(userId, this.data.wp_usage_id)
      .pipe(
        switchMap((res: any) => {
          this.toasterService.showSuccess(res.message, 'success');
          this.favoriteRecordsService.loadFavoriteRecords(userId, this.data.context || 'map', true);
          return this.dataFetchService.checkFavorite(this.userId, this.data.wp_usage_id);
        })
      )
      .subscribe({
        next: (checkRes: FavoriteCheckResponse) => {
          this.data.favorited = !!checkRes.favorited;
          this.isFavoriteLoading = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.isFavoriteLoading = false;
        
          this.cdr.detectChanges();}
      });
  }

  goToCheckoutWP(content:ContentData){
    if (!this.storeLinks.buyContent(content)) {
      this.toasterService.showSuccess('This item is not for sale in the store.', 'danger');
    }
  }

  goToDownloadPage(){
    this.storeLinks.openDownloads();
  }
}
